<script>
import PasswordField from '@phoenix/mixins/components/form/fields/PasswordField';
import { PhxIcon } from '@phx-styleguides/jlc';
import { useField } from '@phoenix/composables/field';

export default {
  components: {
    PhxIcon,
  },

  mixins: [PasswordField],

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <div class="input-with-button">
    <text-field v-model="value" :attrs="fieldAttrs" :should-validate="false" />

    <button type="button" class="btn btn--default btn--icon-only btn--icon" @click="togglePassword">
      <span class="sr-only">{{ togglePasswordText }}</span>
      <span class="btn__icon">
        <phx-icon :icon="togglePasswordIcon" />
      </span>
    </button>
  </div>
</template>
